// Polyfill crypto.randomUUID first — it must exist before any module (Sentry
// included) generates an id in an insecure context (HTTP over a LAN IP).
import "./polyfills/randomUUID";
// Sentry must be imported early so its global handlers are installed before any
// other application module runs. No-op unless VITE_SENTRY_DSN is set.
import { ErrorBoundary } from "./sentry";
import "./errorCatcher";
import "./i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/index.css";
import "boxicons/css/boxicons.min.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary fallback={<div style={{ padding: 24 }}>Something went wrong.</div>}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
